export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6471.77653c04.jpg";